import React from "react";
import { Modal } from "react-bootstrap";
import "./CreateCARModel.styles.css";
import CircleCloseIcon from "../../assets/images/CircleCloseIcon.svg"

interface CreateCARModelProps {
  onCarCreated: (grade: string) => void;
  visible: boolean;
  onHide: () => void;
}

export default function CreateCARModel({ onCarCreated, visible, onHide }: CreateCARModelProps) {
  return (
    <Modal show={visible} onHide={onHide} centered dialogClassName="create-car-modal">
        <div className="header-bar"></div>
      <Modal.Header >
        <div className="modal-title-container">
          <span className="title-text">Create CAR</span>
        </div>
        <img 
            className='modal-img'
            src={CircleCloseIcon}
            onClick={onHide} 
          style={{ cursor: "pointer" }}
            alt="Modal Icon"
            /> 
      </Modal.Header>
      <div className="d-flex align-items-center justify-content-center">
      <div className="horizental-divider"></div>
      </div>

      <Modal.Body>
        <p className="question-text">What Grade is the CAR that you are creating?</p>
        <p className="note-text">Note: The Grade of the CAR cannot be changed once a selection is made.</p>



        <div className="grade-selection">
          {/* Major CAR */}
          <div
            className="grade-option major"
            onClick={() => {
              onCarCreated("Major");
              onHide();
            }}
          >
            <span className="grade-text">Major CAR</span>
            <i className="pi pi-chevron-circle-right" style={{ color: '#C43131' }}></i>
          </div>

          <div className="vertical-divider"></div>

          {/* Minor CAR */}
          <div
            className="grade-option minor"
            onClick={() => {
              onCarCreated("Minor");
              onHide();
            }}
          >
            <span className="grade-text">Minor CAR</span>
            <i className="pi pi-chevron-circle-right" style={{ color: '#F49632' }}></i>
          </div>

          <div className="vertical-divider"></div>

          {/* Observation */}
          <div
            className="grade-option observation"
            onClick={() => {
              onCarCreated("Observation");
              onHide();
            }}
          >
            <span className="grade-text">Observation</span>
            <i className="pi pi-chevron-circle-right" style={{ color: '#919191' }}></i>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
